import '@/styles/shadcn.css';
import '@/styles/login.css';

function initLoginBackground() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  document.querySelectorAll<HTMLElement>('.login-bg__slide').forEach((slide, index) => {
    let direction = index % 2 === 0 ? -1 : 1;

    const applyPan = () => {
      slide.style.setProperty('--pan-x', `${direction * 2.6}%`);
    };

    applyPan();
    slide.addEventListener('animationiteration', (event) => {
      if (event.animationName !== 'login-bg-fade') {
        return;
      }

      direction *= -1;
      applyPan();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoginBackground);
} else {
  initLoginBackground();
}
